import React, { useRef, useState } from 'react';
import { useSearchBox } from 'react-instantsearch';
import styled from 'styled-components';
import {
  brandColours,
  minBreakpointQuery,
  standardColours,
  visuallyHidden,
} from '../styles';
import { Svg } from './ui';
import searchIcon from '../images/search-icon.inline.svg';

const StyledSearchBox = styled.div`
  border: 1px solid ${standardColours.lighterGrey};
`;

const StyledInner = styled.form`
  position: relative;
`;

const StyledLabel = styled.label`
  ${visuallyHidden()};
`;

const StyledInput = styled.input`
  padding: 10px 70px 10px 30px;
  height: 42px;
  width: 100%;
  background: none;
  border: none;

  ${minBreakpointQuery.large`
    padding-right: 60px;
    padding-left: 20px;
    height: 48px;
  `}
`;

const StyledIconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  background-color: ${brandColours.primary};
  border-radius: 50%;
  transform: translateY(-50%);

  ${minBreakpointQuery.large`
    right: 15px;
  `}
`;

const StyledIcon = styled(Svg)`
  height: 14px;
  width: 14px;
  fill: ${standardColours.white};
`;

const SearchBox = props => {
  const { refine, query } = useSearchBox(props);
  const [inputValue, setInputValue] = useState(query);
  const inputRef = useRef(null);

  function setQuery(newQuery) {
    setInputValue(newQuery);

    newQuery.length > 0 && props.setQuery(newQuery);

    newQuery && newQuery.length > 0
      ? props.setSearchOpen(true)
      : props.setSearchOpen(false);

    refine(newQuery);
  }

  return (
    <StyledSearchBox>
      <StyledInner name="search" action="/search" autocomplete="off">
        <StyledLabel for="term">Search our products...</StyledLabel>
        <StyledInput
          ref={inputRef}
          type="search"
          id="term"
          name="term"
          placeholder="Search"
          value={inputValue}
          onChange={e => {
            setQuery(e.currentTarget.value);
          }}
          onFocus={() => {
            if (!query) {
              refine('default search');
              props.setSearchOpen(true);
            } else {
              props.setSearchOpen(true);
            }
          }}
        />
        <StyledIconWrapper>
          <StyledIcon image={searchIcon} />
        </StyledIconWrapper>
      </StyledInner>
    </StyledSearchBox>
  );
};

export default SearchBox;
